import { Box, Button, Paper, Typography } from '@mui/material'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'

import style from './style'
import { useLanguage } from '../../LanguageContext'

type Props = {
  content: React.ReactNode
  imgSrc: string
  title: string
}

const Service = ({ content, imgSrc, title }: Props) => {
  const language = useLanguage()

  return (
    <Paper elevation={3} sx={style.service}>
      <Box>
        <Box component="img" src={imgSrc} sx={style.image} />
        <Box sx={style.content}>
          <Typography variant="h2" fontSize={24} fontWeight={500} color="secondary">
            {title}
          </Typography>

          <p>{content}</p>
        </Box>
      </Box>

      <Button component={Link} to={`/${language}/contact`} variant="contained" sx={style.cta}>
        <FormattedMessage id="Common.ContactUs" defaultMessage="Contact us" />
      </Button>
    </Paper>
  )
}

export default Service
